var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('div',{staticClass:"preloader"},[_c('img',{attrs:{"src":require("../assets/images/logo-air.png")}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }